import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {

  transform(value: any): any {
      if(value){
        var date = new Date(value);
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var _hour = (hour < 10) ? '0' + hour : hour;
        var _minutes = (minutes < 10) ? '0' + minutes : minutes;
        return _hour + ':' + _minutes;
      }
      else{
        return value;
      }
  }
}
